
function extendCountryIban (validator) {
  validator.extend('countryiban', {
    validate: (value, {acceptedCountries}) => {
      if(!acceptedCountries || acceptedCountries.length == 0) {
        return true;
      }
      if(
        !acceptedCountries.includes(value.substring(0, 2).toUpperCase())
      ) {
        return false;
      }
      return true;
    }
  }, ['acceptedCountries']);
}
export default extendCountryIban;
